import React, { useState } from "react";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { RejectPaymentApi } from "../../../api/request/report";

const RejectPaymentModal = ({ isOpen, setIsOpen, payment, setStatusData }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleReject = async (value) => {
    setIsLoading(true);
    try {
      const params = {
        file_id: payment?.file_id,
        reason: value?.reason,
      };
      const { data } = await RejectPaymentApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setStatusData("unpaid", value?.reason);
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Reject Payment Request"
    >
      <Form autoComplete="off" layout="vertical" onFinish={handleReject}>
        <Form.Item
          name="reason"
          label="Reason"
          className="mb-0"
          rules={[{ required: true, message: "Please enter reason" }]}
        >
          <Input.TextArea rows={4} placeholder="Reason" />
        </Form.Item>

        <div className="text-center mt-5">
          <LoadableButton
            type="submit"
            lable="Submit"
            isLoading={isLoading}
            loadingLable="Submitting..."
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default RejectPaymentModal;
